<template>
  <div class="common-search-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="余额明细" name="log"></el-tab-pane>
      <el-tab-pane label="余额提现" name="cash"></el-tab-pane>
    </el-tabs>
    <!--余额明细-->
    <Log v-if="activeName == 'log'"></Log>
    <Cash v-if="activeName == 'cash'"></Cash>
  </div>
</template>
<script>
import Log from './part/Log';
import Cash from './part/Cash';
export default {
  components: {
    Log,
    Cash
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'log'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/balance/index.vue